import { TranslocoService } from "@jsverse/transloco";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { absoluteUrl } from "src/app/support/navigation";
import { NavigationBarItem } from "../bootstrap-components/navigation-bar/navigation-bar-item";

export function getRocketSettingsMenu(
  transloco: TranslocoService,
  facility: string
): NavigationBarItem[] {
  return [
    {
      title: transloco.translate(marker("Account")),
      url: absoluteUrl("/account"),
      icon: "fa-light fa-circle-user"
    }
  ];
}
